import fluxValidation from './validation';

var fluxStepper = {
    steps_hash: {
        1: 'details',
        2: 'address',
        3: 'payment'
    }
};

/**
 * Run.
 */
fluxStepper.init = function() {
    window.location.hash = this.steps_hash[1];
    this.onNextClick();
    this.onStepperClick();
    this.supportNavigationButtons();
};

/**
 * Validation on Step change.
 * 
 * By default Woo does not provide inline validation messages. 
 * We use AJAX to get the correct message and then trigger Woo validation.
 */
fluxStepper.onNextClick = function(){
    var steps = document.querySelectorAll( '[data-step-next]' );
    Array.from( steps ).forEach( function( step ) {
        step.addEventListener( 'click', async function( e ) {
            e.preventDefault();
            fluxStepper.loadSpinner();

            fluxValidation.clearErrorMessages();

            var fields = fluxStepper.getFields( step.closest( '[data-step]' ) );
            var hasErrors = await fluxValidation.checkFieldsForErrors( fields );
            
            if ( hasErrors ) {
                return false;
            }

            var nextStepNumber = step.attributes[ 'data-step-show' ].value;
            var nextStep = document.querySelector( '[data-step="' + nextStepNumber + '"]' ); // ES5 Support.

            if ( ! nextStep ) {
                return false;
            }

            // Only change the hash. Panels will be toggled by hashchange vent listener.
            window.location.hash = '#'+fluxStepper.steps_hash[ nextStepNumber ];
            
            // Woo trigger select2 reload.
            jQuery( document.body ).trigger( 'country_to_state_changed' );
            
            return false;
        }); 
    } );
};

fluxStepper.onStepperClick = function(){
    var steppers = document.querySelectorAll( '[data-stepper]' );
    Array.from( steppers ).forEach( function( stepper ) {

        stepper.addEventListener( 'click', async function( e ) {
            e.preventDefault();

            fluxValidation.clearErrorMessages();

            var hasErrors = false;
            var stepNumber = stepper.attributes[ 'data-stepper' ].value;
            var isActive = stepper.closest( '[data-stepper-li]' ).classList.contains( 'selected' );

            if ( isActive ) {
                return false;
            }

            // Check current step fields.
            if ( stepNumber > 1 ) {
                // var fields = fluxStepper.getFields( document.querySelector( `[data-step="${ stepNumber - 1}"]` ) ); 
                var fields = fluxStepper.getFields( document.querySelector( '[data-step="' + ( stepNumber - 1 ) + '"]' ) ); // ES5 Support.
                hasErrors = await fluxValidation.checkFieldsForErrors( fields );
            }

            if ( hasErrors ) {
                return false;
            }

            // Only change the hash. Panels will be toggled by hashchange vent listener.
            window.location.hash = '#' + fluxStepper.steps_hash[ stepNumber ];

            // Woo trigger select2 reload.
            jQuery( document.body ).trigger( 'country_to_state_changed' );
            
            return false;
        }); 
    } );
};

/**
 * Disable Next Steppers.
 * 
 * @param {int} stepNumber The Step Number.
 */
fluxStepper.disableNextSteppers = function( stepNumber ) {
    Array.from( document.querySelectorAll( '[data-stepper-li]' ) ).forEach( function ( stepper ) {
        if ( stepNumber === stepper.attributes['data-stepper-li'].value ) {
            stepper.classList.remove( 'complete' );
        }
        if ( stepNumber >= stepper.attributes['data-stepper-li'].value ) {
            return;
        }
        stepper.classList.add( 'disabled' );
        stepper.classList.remove( 'complete' );
        stepper.querySelector( '[data-stepper]' ).setAttribute( 'disabled', 'disabled' );
        stepper.querySelector( '[data-stepper]' ).setAttribute( 'aria-disabled', 'true' );
    } );
};

/**
 * Complete Previous Steps.
 * 
 * @param {int} stepNumber The Step Number.
 */
fluxStepper.completePreviousSteppers = function( stepNumber ) {
    Array.from( document.querySelectorAll( '[data-stepper-li]' ) ).forEach( function ( stepper ) {
        if ( stepper.attributes['data-stepper-li'].value >= stepNumber  ) {
            return;
        }
        stepper.classList.add( 'complete' );
    } );
};

/**
 * Disable Next Steppers.
 * 
 * @param {int} currentStepNumber The current step number.
 * @param {int} nextStepNumber The next step number.
 */
fluxStepper.switchStepper = function( currentStepNumber, nextStepNumber ) {
    // Steppers.
    // var currentStepper = document.querySelector( `[data-stepper-li="${currentStepNumber}"]` );
    var currentStepper = document.querySelector( '[data-stepper-li="' + currentStepNumber + '"]' ); // ES5 Support
    // var nextStepper = document.querySelector( `[data-stepper-li="${nextStepNumber}"]` );
    var nextStepper = document.querySelector( '[data-stepper-li="' + nextStepNumber + '"]' ); // ES5 Support.

    // Handle Steppers.
    currentStepper.classList.remove( 'error' );
    currentStepper.classList.remove( 'disabled' );
    currentStepper.querySelector( 'button' ).removeAttribute('disabled');
    currentStepper.querySelector( 'button' ).removeAttribute('aria-disabled');
    currentStepper.classList.remove( 'selected' );
    nextStepper.classList.remove( 'error' );
    nextStepper.classList.remove( 'disabled' );
    nextStepper.querySelector( 'button' ).removeAttribute('disabled');
    nextStepper.querySelector( 'button' ).removeAttribute('aria-disabled');
    nextStepper.classList.add( 'selected' );

    fluxStepper.completePreviousSteppers( nextStepNumber );
};

/**
 * Switch Panels
 * 
 * @param {int} currentStepNumber The current step number.
 * @param {int} nextStepNumber The next step number.
 */
fluxStepper.switchPanels = function( currentStepNumber, nextStepNumber ) {
    var currentStep = document.querySelector( '[data-step="' + currentStepNumber + '"]' );
    var nextStep = document.querySelector( '[data-step="' + nextStepNumber + '"]' );
    
    currentStep.style.display = 'none';
    currentStep.setAttribute( 'aria-hidden', 'true' ); 
    
    nextStep.style.display = '';
    nextStep.setAttribute( 'aria-hidden', 'false' ); 
    
    window.scrollTo( 0, 0 );
};

/**
 * Get Fields.
 * 
 * Get all the fields that are relevant to the current step.
 * 
 * @param {element} parent Parent Element.
 */
fluxStepper.getFields = function( parent ) {
    var allFields = parent.querySelectorAll( 'input, select, textarea' );
    var accountFields = parent.querySelectorAll( '.create-account input, .create-account select, .create-account textarea' );
    var shippingFields = parent.querySelectorAll( '.woocommerce-shipping-fields input, .woocommerce-shipping-fields select, .woocommerce-shipping-fields textarea' );
    var additionalFields = parent.querySelectorAll( '.woocommerce-additional-fields input, .woocommerce-additional-fields select, .woocommerce-additional-fields textarea' );
    
    var fields = [];

    Array.from( allFields ).forEach( function( field ) {
        if ( ( ! parent.querySelectorAll( 'input[name=createaccount]:checked' ).length && ! parent.querySelectorAll( '.create-account[style="display:block;"]' ).length ) && Array.from( accountFields ).includes( field ) ) {
            return;
        }

        if ( ! parent.querySelectorAll( 'input[name=ship_to_different_address]:checked' ).length && Array.from( shippingFields ).includes( field ) ) {
            return;
        }

        if ( ! parent.querySelectorAll( 'input[name=show_additional_fields]:checked' ).length && Array.from( additionalFields ).includes( field ) ) {
            return;
        }

        fields.push( field );
    } );

    return fields;
};

fluxStepper.supportNavigationButtons = function() {
    window.addEventListener( 'hashchange', async function() {
        if ( ! window.location.hash ) {
            return;
        }

        var hash = window.location.hash.replace( '#', '' );
        var nextStepper = document.querySelector( '[data-hash="' + hash + '"]' );
        var nextStepNumber = nextStepper.attributes[ 'data-stepper' ].value;
        var stepper = document.querySelector( '.flux-stepper__step.selected .flux-stepper__button' );
        var currentStepNumber = stepper.attributes['data-stepper'].value;
        var hasErrors = false;
        var stepNumber = stepper.attributes[ 'data-stepper' ].value;
        var isActive = nextStepNumber === currentStepNumber;

        fluxValidation.clearErrorMessages();

        if ( isActive ) {
            return false;
        }

        // Check current step fields.
        if ( nextStepNumber > currentStepNumber ) {
            var fields = fluxStepper.getFields( document.querySelector( '[data-step="' + currentStepNumber + '"]' ) );
            hasErrors = await fluxValidation.checkFieldsForErrors( fields );
        }

        if ( hasErrors ) {
            window.location = '#' + stepper.attributes['data-hash'].value;
            return false;
        }

        fluxStepper.switchPanels( stepNumber, nextStepNumber );
        fluxStepper.switchStepper( stepNumber, nextStepNumber );

        if ( 'address' === hash || 'payment' === hash ) {
            jQuery( document.body ).trigger( 'update_checkout' );
            jQuery( "#billing_country" ).trigger( 'change' );
        }

        // Woo trigger select2 reload.
        jQuery( document.body ).trigger( 'country_to_state_changed' );
    } );
};

/**
 * Load the Spinner.
 */
fluxStepper.loadSpinner = function() {
    Array.from( document.querySelectorAll( '[data-step-next]' ) ).forEach( function( step ) {
        step.setAttribute( 'disabled', true );
    });
    document.querySelector( '.flux-checkout__spinner' ).style.display = 'block';
};

/**
 * Remove the Spinner.
 */
fluxStepper.removeSpinner = function() {
    Array.from( document.querySelectorAll( '[data-step-next]' ) ).forEach( function( step ) {
        step.removeAttribute( 'disabled' );
    });
    document.querySelector( '.flux-checkout__spinner' ).style.display = 'none';
};

export default fluxStepper;